import PropTypes from 'prop-types'
import React from 'react'

import EmailInputHint from '@components/email_input_hint'
import InputWarning from '@components/input_warning'

import {
  InputError,
  InputLabel,
  InputPlaceholder,
  InputHint,
  InputSubLabel
} from './children'
import {
  canRenderPlaceholder,
  canRenderError,
  canRenderHint,
  getLabelId,
  shouldRenderEmailHint
} from './helpers'

export default class FormFieldBase extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
    this.handleFocus = this.handleFocus.bind(this)
    this.handleBlur = this.handleBlur.bind(this)
  }

  handleFocus() {
    this.props.focusHandler(this.props.id)
    this.setState({ focused: true })
  }

  handleBlur() {
    this.props.blurHandler(this.props.id)
    this.setState({ focused: false })
  }

  processChange(...args) {
    this.props.valueHandler(this.props.id, ...args)
  }

  renderHint() {
    if (!canRenderHint(this.props, this.state)) return

    return <InputHint hint={this.props.hint} />
  }

  renderSubLabel() {
    if (
      shouldRenderEmailHint(
        this.props.consumerGroup,
        this.props.isVerificationEmail
      )
    ) {
      return <EmailInputHint consumerGroup={this.props.consumerGroup} />
    }

    if (!this.props.subLabel) return

    return <InputSubLabel subLabel={this.props.subLabel} />
  }

  renderPlaceholder(ref) {
    if (!canRenderPlaceholder(this.props, this.state)) return

    return (
      <InputPlaceholder
        inputRef={ref}
        placeholder={this.props.placeholder}
        subLabel={this.props.subLabel}
      />
    )
  }

  renderInputError(consumerGroup) {
    if (!canRenderError(this.props, this.state)) return null

    return (
      <InputError
        error={this.props.error}
        handleErrorAction={this.props.errorAction}
        errorActionText={this.props.errorActionText}
        consumerGroup={consumerGroup}
      />
    )
  }

  renderInputWarning() {
    const { warning } = this.props

    return (
      <InputWarning
        warning={warning}
        {...this.props}
      />
    )
  }

  renderInputLabel() {
    if (!this.props.label) return

    return (
      <InputLabel
        id={getLabelId(this.props.id)}
        htmlFor={this.props.id}
        value={this.props.label}
        optional={this.props.optional}
      />
    )
  }

  render() {
    return null
  }
}

FormFieldBase.defaultProps = {
  isVerificationEmail: false,
  consumerGroup: 'student',
  warning: ''
}

FormFieldBase.propTypes = {
  id: PropTypes.string.isRequired,
  focusHandler: PropTypes.func,
  blurHandler: PropTypes.func,
  valueHandler: PropTypes.func.isRequired,
  error: PropTypes.string,
  hint: PropTypes.string,
  label: PropTypes.string.isRequired,
  optional: PropTypes.bool,
  subLabel: PropTypes.string,
  value: PropTypes.string.isRequired,
  isVerificationEmail: PropTypes.bool,
  consumerGroup: PropTypes.string,
  warning: PropTypes.string
}
